import { useState, ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../sidebar/SuperAdminSidebar";
import Header from "../header/Header";
import { useAppSelector } from "../../store/hooks";

interface SuperAdminLayoutProps {
  children: ReactNode;
}

const SuperAdminLayout: React.FC<SuperAdminLayoutProps> = ({ children }) => {
  const location = useLocation();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const user = useAppSelector((state) => state.auth.user);

  const toggleSidebar = () => {
    setIsSidebarCollapsed((prev) => !prev);
  };

  useEffect(() => {
    console.log("🔁 Current route path:", location.pathname);
  }, [location]);

  const sidebarWidth = isSidebarCollapsed ? "w-16" : "w-64";

  return (
    <div className="min-h-screen bg-light dark:bg-dark text-dark dark:text-light transition-colors">
      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-40 ${sidebarWidth} bg-slate-900 text-white transition-all duration-300`}
      >
        <Sidebar isCollapsed={isSidebarCollapsed} />
      </div>

      {/* Main Content */}
      <div
        className={`min-h-screen flex flex-col transition-all duration-300
        ${isSidebarCollapsed ? "md:pl-16" : "md:pl-64"}`}
      >
        <Header
          onToggleSidebar={toggleSidebar}
          isCollapsed={isSidebarCollapsed}
          user={
            user && user.name && user.role
              ? { name: user.name, role: user.role }
              : null
          }
        />

        {/* User Info */}
        {user && (
          <div className="px-6 pt-4 text-sm text-slate-600 dark:text-slate-300">
            Welcome <span className="font-semibold">{user.name}</span> (
            {user.role})
          </div>
        )}

        {/* Main content area */}
        <main className="pt-pt-14 px-2">{children}</main>
      </div>
    </div>
  );
};

export default SuperAdminLayout;
